import React from 'react'
import { Form, Field, Formik } from 'formik'
import { Row, Col } from 'antd'
import PropTypes from 'prop-types'
import { AntInput } from '../../form-handlers/AntFieldFactory'
import { Text } from '../../common'

const DisplayCustomerDetailForm = ({ handleSubmit, handleReset, values, submitCount, dirty, isSubmitting }) => (
  <Form className='form-container' onSubmit={handleSubmit} onReset={handleReset}>
    <Row gutter={16}>
      <Col span={12}>
        <Field
          component={AntInput}
          name='first_name'
          type='input'
          label='Nombre'
          hasFeedback
        />
      </Col>
      <Col span={12}>
        <Field
          component={AntInput}
          name='last_name'
          type='input'
          label='Apellido'
          hasFeedback
        />
      </Col>
    </Row>
    <Row gutter={16}>
      <Col span={12}>
        <Field
          component={AntInput}
          name='email'
          type='email'
          label='Email'
          hasFeedback
        />
      </Col>
      <Col span={12}>
        <Field
          component={AntInput}
          name='document'
          type='input'
          label='RUT'
          hasFeedback
        />
      </Col>
    </Row>

    <div style={{ position: 'absolute', bottom: 30, right: 10 }}>
      <Row type='flex' gutter={24} align='bottom' justify='end'>
        <Col>
          <div className='submit-container flex justify-content-flex-end'>
            <button className='ant-btn' type='reset' disabled={isSubmitting || !dirty}>
              <Text text='form.btn.cancel' />
            </button>
            <button className='ant-btn ant-btn-primary' type='submit' disabled={isSubmitting} loading={isSubmitting}>
              <Text text='form.btn.submit' />
            </button>
          </div>
        </Col>
      </Row>
    </div>

  </Form>
)

class CustomerDetailForm extends React.Component {
  handleSubmit = (values, { setSubmitting }) => {
    const { onSubmit, initialValues } = this.props
    const { id } = initialValues
    const { document, email, first_name: firstName, last_name: lastName } = values
    const payload = { id, document, email, firstName, lastName }
    onSubmit(payload)
      .then(() => setSubmitting(false))
      .catch(() => setSubmitting(false))
  };

  handleReset = () => {
    console.log('handle-reset')
    this.props.onReset()
  }
  render () {
    const { initialValues } = this.props
    return (
      <Formik
        enableReinitialize
        initialValues={initialValues}
        onSubmit={this.handleSubmit}
        onReset={this.handleReset}
        render={DisplayCustomerDetailForm}
      />
    )
  }
}

CustomerDetailForm.propTypes = {
  initialValues: PropTypes.object,
  onReset: PropTypes.func,
  onSubmit: PropTypes.func
}

CustomerDetailForm.defaultProps = {
  onReset: () => null
}

export default CustomerDetailForm
